module.exports = __webpack_public_path__ + "media/static/logo-tdc-d506c18b2fb72e071e2e5e58262c6abe.png";